'use strict';

/**
 * Empty list item for the trash list
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/trash-list-empty.hbs');

var ImportTrashListEmptyItem = ColidoItemView.extend({
    template: template,

    tagName: 'tr',
});

module.exports = ImportTrashListEmptyItem;